export default "__VITE_ASSET__d399ea93__"